import moment from "moment/min/moment-with-locales";
import { Card, Col, Stack } from "react-bootstrap";
import ErrorResponse from "../ErrorResponse";

export default function ClocksSessionsCard({ data, dataLoading, error }) {
    if (!data && !dataLoading && !error) return;
    const tslData = data?.data[0]?.tsl?.[0] ?? { count: 0, tsl: 0, count_average: 0, tsl_average: 0 };

    const formatTime = seconds => moment.utc(moment.duration(seconds, "s").asMilliseconds()).format("HH:mm:ss");
    return (
        <Card>
            <Card.Header className="fs-7">Sessions</Card.Header>
            <Card.Body className="p-1">
                {error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    <Stack direction="horizontal">
                        <Col>
                            <Stack>
                                <Stack direction="horizontal" className="fw-bold fs-7 text-center justify-content-center">
                                    <span>{dataLoading || !tslData.count || !data ? "-" : tslData.count}</span>
                                </Stack>
                                <span className="text-center fs-8">Sessions</span>
                                <span className="text-center text-muted fst-italic fs-8">
                                    <span>AVG </span>
                                    <span>{dataLoading || !tslData.count_average || !data ? "-" : Math.round(tslData.count_average)}</span>
                                </span>
                            </Stack>
                        </Col>
                        <div className="vr"></div>
                        <Col>
                            <Stack>
                                <Stack direction="horizontal" className="fw-bold fs-7 text-center justify-content-center">
                                    <span>{dataLoading || !data || !tslData.tsl ? "--:--:--" : formatTime(tslData.tsl)}</span>
                                </Stack>
                                <span className="text-center fs-8">TSL</span>
                                <span className="text-center text-muted fst-italic fs-8">
                                    <span>AVG </span>
                                    <span>{dataLoading || !data || !tslData ? "--:--:--" : formatTime(tslData.tsl_average)}</span>
                                </span>
                            </Stack>
                        </Col>
                    </Stack>
                )}
            </Card.Body>
        </Card>
    );
}
